import { parse } from "date-fns";

// Parses a YYYY-MM-DD day identifier into a local Date (no TZ shift)
export const parseDayIdToLocalDate = (dayId: string): Date =>
  parse(dayId, "yyyy-MM-dd", new Date());
